import type { ReactNode } from 'react';
import { formatSellerType } from '../../../helpers/formatting';
import {
  InfoTitle,
  InfoTitleProps,
} from '../../../components/Toolkit/InfoTitle/InfoTitle';
import * as Styled from '../../../components/Toolkit/MiniUserProfile/MiniUserProfile.styled';

export interface MiniUserProfileProps extends InfoTitleProps {
  county?: string;
  type?: string | null;
  franchiseType?: string;
  isTrader: boolean;
  verification?: { email?: boolean; phone?: boolean; bank?: boolean };
  isDealer?: boolean;
  className?: string;
  position?: 'MAIN' | 'SIDE';
  subtitleComponent?: ReactNode;
  renderAdditionalHeaderInfo?: ReactNode;
  onClickSubtitle?: () => void;
}

function MiniUserProfile({
  title,
  illustration,
  county,
  type,
  franchiseType,
  isTrader,
  verification,
  isDealer = false,
  className,
  position = 'MAIN',
  subtitleComponent,
  renderAdditionalHeaderInfo,
  icon,
  onClickSubtitle,
}: MiniUserProfileProps) {
  return (
    <Styled.MiniUserProfile className={className}>
      <InfoTitle
        title={title}
        illustration={illustration}
        icon={icon}
        listItems={
          subtitleComponent
            ? [subtitleComponent]
            : isDealer
            ? position === 'MAIN'
              ? [
                  <Styled.FranchiseButton
                    ofType="SECONDARY"
                    fontSize="M16"
                    colorVariant="GREY_DARK"
                    onClick={onClickSubtitle}
                    key="franchise-button"
                  >
                    {franchiseType}
                  </Styled.FranchiseButton>,
                ]
              : [county]
            : [formatSellerType(isTrader, verification, type), county]
        }
        shouldTruncate
      />
      {renderAdditionalHeaderInfo && <>{renderAdditionalHeaderInfo}</>}
    </Styled.MiniUserProfile>
  );
}

export { MiniUserProfile };
